import { render, staticRenderFns } from "./BoxInspectionsTableDetails.vue?vue&type=template&id=fe9f21ce&scoped=true"
import script from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
export * from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
import style0 from "./BoxInspectionsTableDetails.vue?vue&type=style&index=0&id=fe9f21ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9f21ce",
  null
  
)

export default component.exports